import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./GenAIContent.css";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import ToolSuiteSection from "./ToolSuiteSection";

function GenAIContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
      <div className="genai-banner-container" id="main">
        <title>L-TT GenAI Tools</title>
        <h1 class="sr-only" tabIndex={0}>
          GenAI Tools
        </h1>
        <img
          src={
            process.env.PUBLIC_URL + "/images/GenAI/GenAI-Banner-Brand-New.png"
          }
          alt="genai-banner"
          className="banner-img"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/GenAI-Tools"
            >
              GenAI Tools
            </NavLink>
          </li>
        </ul>
        <p data-aos="fade-up">
          Welcome to GenAI tools suite offers a wide array of GenAI-powered
          tools designed to make learning more dynamic, efficient, and
          personalized at ATCI. Leverage these innovative solutions to enhance
          productivity and stay relevant in the evolving tech landscape.
        </p>
      </div>
      {/* first section */}
      <div className="tools-suite-container">
        <div className="tools-suite-wrap">
          <div className="heading-box">
            <h2 className="main-headings">GenAI Tools Suite</h2>
            <p>Tap into the magic of GenAI!</p>
          </div>
          <ToolSuiteSection />
        </div>
      </div>
    </>
  );
}

export default GenAIContent;
